<template>
    <div>
        <SelectDropdown
            :add-new="hasFilters"
            :auto-translate="false"
            class="w-324"
            deletable
            enable-when-no-options
            :loading="loading"
            :options="analyticsPresetsOptions"
            :placeholder="$t('analytics.presets.dropdown')"
            placeholder-class="mr-auto leading-none"
            searchable
            :search-placeholder="$t('analytics.presets.search')"
            v-model="selectedFilter"
            @change="setFilters"
            @delete="deletingId = $event"
            @new="store($event)"
        />

        <PopupModalConfirm v-if="deletingId" @close="deletingId = null" @confirm="deletePreset"
                           title="Are you sure you want to delete this view?"/>
    </div>
</template>

<script>
import AnalyticsPreset from "../models/AnalyticsPreset";
import SelectDropdown from "./forms/SelectDropdown.vue";
import PopupModalConfirm from "./ui/PopupModalConfirm.vue";
import {useRepo} from "pinia-orm";

export default {
    components: {PopupModalConfirm, SelectDropdown},
    props: {
        filters: Object
    },
    data() {
        return {
            selectedFilter: null,
            loading: false,
            deletingId: null
        }
    },
    computed: {
        analyticsPresets() {
            return useRepo(AnalyticsPreset).all();
        },
        analyticsPresetsOptions() {
            return this.analyticsPresets.map(preset => {
                return {
                    value: preset.id,
                    label: preset.name
                }
            });
        },
        hasFilters() {
            return !!Object.keys(this.filters).find(key => {
                if (key === 'withArchived')
                    return false;

                const value = this.filters[key];
                if (Array.isArray(value))
                    return value.length > 0;

                return !!value;
            });
        }
    },
    methods: {
        clear() {
            this.selectedFilter = null;
        },
        store(name) {
            this.loading = true;

            AnalyticsPreset.dbStore({name, filters: this.filters}).then(data => {
                this.selectedFilter = data.id;
                this.loading = false;
            });
        },
        setFilters(selectedId) {
            this.selectedFilter = selectedId;
            const preset = this.analyticsPresets.find(preset => preset.id === this.selectedFilter);
            if (preset) {
                this.$emit('set-filters', preset.filters);
            }
        },
        deletePreset() {
            AnalyticsPreset.dbDelete(this.deletingId).then(() => {
                useRepo(AnalyticsPreset).destroy(this.deletingId);
                this.deletingId = null;
            });
        }
    },
    mounted() {
        AnalyticsPreset.fetch();
    }
}
</script>
